var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollbox",staticClass:"scroll-box"},[_c('bannaerCom'),_c('div',{attrs:{"id":"aboutUs"}},[_c('aboutUsCom'),_c('organizationCom'),_c('businessCom'),_c('swiperImgListCom')],1),_c('journalCom'),_c('memberCom'),_c('activityCom'),_c('MembershipstyleCom'),_c('JoinUsCom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }